import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import {Constants,IMAGES_BASE_URL} from './config';
import { ImageLoader } from 'ionic-image-loader';
import { Api } from './api';
import {CartManager} from './cart-manager';
import {AlertController,ToastController,LoadingController } from 'ionic-angular';
import {GVLogger} from "../services/gv-logger";


@Injectable()
export class Settings {
	private STAY_SIGNED_IN_KEY = "signedIn";
	private STAY_AWAKE_KEY = "stayAwake";

  isWebstore = 0;

  imagesLoadedCount = 0;
  requestComplete = true;
  loader :any;
  countryCode: string;

constructor(private storage:Storage,
	private imageLoader:ImageLoader,
	private toastCtrl:ToastController,
	private api: Api,
	private loadingCtrl:LoadingController,
	private alertCtrl:AlertController,
  private cartManager:CartManager,
  private gVLogger:GVLogger){
  this.imagesLoadedCount = 0;

  if(Constants.isWebstore){
    this.isWebstore = 1;
  }

}

setStaySignedIn(isSignedIn){
	//this.storage.set(this.STAY_SIGNED_IN_KEY,isSignedIn)

	localStorage.setItem(this.STAY_SIGNED_IN_KEY,isSignedIn);
}

getStaySignedIn(){
	var res:string = localStorage.getItem(this.STAY_SIGNED_IN_KEY);
	if(res == "true"){
		return true;
	}else{
		return false;
	}
}

setStayAwake(isStayAwake){
	localStorage.setItem(this.STAY_AWAKE_KEY,isStayAwake);
}

getStayAwake(){
	var res:string = localStorage.getItem(this.STAY_AWAKE_KEY);
	if(res == "true"){
		return true;
	}else{
		return false;
	}
}


  // clearImagesCache(){

  //    let alert = this.alertCtrl.create({
  //   title: 'Are you sure?',
  //   message: 'Do you want to clear images cache?',
  //   buttons: [
  //     {
  //       text: 'Cancel',
  //       role: 'cancel',
  //       handler: () => {
  //         this.gVLogger.log('Cancel clicked');
  //       }
  //     },
  //     {
  //       text: 'Clear Cache',
  //       handler: () => {
  //         this.imageLoader.clearCache();
  //         this.gVLogger.log("images cache cleaned");
  //       }
  //     }
  //   ]
  // });
  // alert.present();

  // }




  preLoadImages(){


   this.presentLoading();
   // Not found image
   this.imageLoader.preload(IMAGES_BASE_URL+"products/default2/dummy-400x400.png");
   this.getImagesURLs(this.imagesLoadedCount, Constants.imagesPreloadBuffer).then(()=>{
         this.gVLogger.log("Image loaded count:"+this.imagesLoadedCount);
         this.requestComplete = true;
      });

  }





presentToast(msg,duration,location) {
  let toast = this.toastCtrl.create({
    message: msg,
    duration: duration,
    position: location
  });
  toast.present();
}


getImagesURLs(startPoint , endPoint){
  this.gVLogger.log("getting images from server");
  return new Promise(resolve => {
  this.api.get("/products/images/"+startPoint+"/"+endPoint+"?isWebStore="+this.isWebstore)
  .map(res=>res.json())
  .subscribe(result =>{
      this.gVLogger.log(result);


      if(!result.data){
        result.data = [];
      }

      for(let img of result.data){


        this.imageLoader.preload(this.cartManager.makeImageURLFromImage("400x400",img));
        this.imageLoader.preload(this.cartManager.makeImageURLFromImage("80x80",img));
      }

      if(result.data.length > 0){
        this.imagesLoadedCount += result.data.length;
        this.getImagesURLs(this.imagesLoadedCount, Constants.imagesPreloadBuffer);
      }else{

        this.storage.set("cacheCompleted"+this.cartManager.getADPCustomerUUID(),true);
        this.presentToast("Loaded all images: "+this.imagesLoadedCount,3000,'bottom');
        this.loader.dismiss();
      //  SpinnerDialog.hide();
      }
      resolve(true);
  },
  err =>{
     this.presentToast("Something went wrong",3000,'bottom');
     this.loader.dismiss();
  });
  });

}




presentLoading() {

    this.loader = this.loadingCtrl.create({
      content: "Loading Images...",
      enableBackdropDismiss : false,
      dismissOnPageChange : false
    });
    this.loader.present();
  }


}



// WEBPACK FOOTER //
// ./src/providers/settings.ts